// TODO: remove once tanstack router is implemented
import type { FilterGroupItem, FilterItem, FilterLineItem } from '@civilgrid/ui/utils';

const OPERATOR_MAP: Record<string, string> = {
  isEqualTo: 'eq',
  isNotEqualTo: 'neq',
  includes: 'like',
  doesNotInclude: 'nlike',
  isFalse: 'eq',
  isTrue: 'eq',
  greaterThan: 'gt',
  greaterThanOrEqualTo: 'gte',
  lessThan: 'lt',
  lessThanOrEqualTo: 'lte',
  in: 'in',
  notIn: 'nin',
};

type UrlFilterNode =
  | { type: 'group'; id: string; condition: 'and' | 'or'; children: UrlFilterNode[] }
  | { type: 'rule'; id: string; columnId: string; operator: string; value: unknown };

function convertNode(node: UrlFilterNode): FilterItem | null {
  if (node.type === 'group') {
    const items = node.children.flatMap((child) => {
      const converted = convertNode(child);
      return converted ? [converted] : [];
    });
    const group: FilterGroupItem = {
      type: 'group',
      id: node.id,
      operator: node.condition ?? 'and',
      items,
    };
    return group;
  }

  if (node.type === 'rule') {
    const operatorId = OPERATOR_MAP[node.operator] ?? node.operator;
    const line: FilterLineItem = {
      type: 'line',
      id: node.id,
      operator: 'and',
      filterType: { id: node.columnId, label: node.columnId },
      operatorType: { id: operatorId, label: operatorId },
      value: node.value != null ? String(node.value) : undefined,
    };
    return line;
  }

  return null;
}

/**
 * Parses the `filter-state` URL search param and converts it to a FilterGroupItem.
 * Returns null if the param is absent, invalid, or cannot be converted.
 * TODO: remove when migrating to TanStack Router
 */
export function parseUrlFilters(): FilterGroupItem | null {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('filter-state');
    if (!raw) return null;

    const parsed = JSON.parse(raw) as UrlFilterNode[];
    if (!Array.isArray(parsed) || parsed.length === 0) return null;

    const root = parsed[0];
    const converted = convertNode(root);
    if (!converted || converted.type !== 'group') return null;

    return converted;
  } catch {
    return null;
  }
}
